import CustomDataTable from './CustomDataTable';

export default CustomDataTable;